import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

export interface SkeletonSectionConfig {
  title?: boolean;
  rows?: number;
  width?: string;
  height?: string;
  className?: string;
}

@Component({
  selector: 'ush-skeleton-loader',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SkeletonModule]
})
export class SkeletonLoaderComponent {
  @Input() sections: SkeletonSectionConfig[] = [];
}
